<template>
  <div>
    <v-dialog
        class="hide-on-print"
        v-model="entryRefuseDialog"
        persistent
        width="800">

      <v-card class="hide-on-print">
        <v-toolbar color="red darken-3" dark>
          <v-toolbar-title>Entry Refuse Traveller</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-container grid-list-md class="pb-0">
            <v-layout wrap>
              <FormErrorDisplayHandler :errors="errors"/>
              <v-flex xs12>
                <v-form class="pa-2" lazy-validation ref="manualRef">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                          label="Submission Number"
                          outlined
                          v-model="entryRefuseData.submission_no"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                          :rules="[rules.required]"
                          label="Flight Number *"
                          outlined
                          v-model="entryRefuseData.flight_number"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                          :items="purpose_of_arrivals"
                          flat
                          solo
                          outlined
                          label="Purpose of visit"
                          v-model="entryRefuseData.purpose_of_visit"
                          clearable
                          hide-details
                          prepend-inner-icon="filter_list"
                          class="mb-4"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-menu
                          ref="menu"
                          v-model="startDateMenu"
                          :close-on-content-click="false"
                          :return-value.sync="entryRefuseData.entry_refuse_date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="entryRefuseData.entry_refuse_date"
                              label="Entry Refuse Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="entryRefuseData.entry_refuse_date"
                            no-title
                            scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              color="primary"
                              @click="menu = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                              text
                              color="primary"
                              @click="$refs.menu.save(entryRefuseData.entry_refuse_date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                          :rules="[rules.required]"
                          label="Remarks *"
                          outlined
                          v-model="entryRefuseData.remarks"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <file-input
                          :required="true"
                          v-model="entryRefuseData.file"
                          placeholder="JPG, PNG, JPEG, PDF & DOCX ONLY"
                          label="Attach Document *"
                      ></file-input>
                    </v-flex>


                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider style="margin-top:31px;"/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              @click="cancel"
              class="white--text"
              color="red darken-3"
              :loading="loading"
          >Cancel
          </v-btn>
          <v-btn
              @click="save"
              class="white--text"
              color="blue darken-3"
              :loading="loading"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {validationMixin} from "../../mixins/validationMixin";
import {VERSIONED_API_URL} from "../../config/config";
import Http from "axios"
import MultipleFileUpload from "../MultipleFileUpload";
import FormErrorDisplayHandler from "../FormErrorDisplayHandler";
import {mapGetters} from 'vuex';
import debounce from 'lodash/debounce';
import FileAttached from "../visa/history/FileAttached";
import FileInput from "../FileInput";
import {fetchDynamicValues} from "../../helpers/dynamicValueHelper";

export default {
  name: "SpecialCasePaymentDialog",
  components: {FileInput, FileAttached, MultipleFileUpload, FormErrorDisplayHandler},
  props: ['travellerId','countryName'],
  mixins: [validationMixin],

  data() {
    return {
      startDateMenu: false,
      entryRefuseData: {},
      innerOpen: false,
      errorMessage: '',
      errors: [],
      loading: false,
      purpose_of_arrivals:[]
    }
  },
  mounted() {
    fetchDynamicValues('PurposeOfArrival').then((res) => {
      this.purpose_of_arrivals = res;
    })
  },
  computed: {
    ...mapGetters({
      entryRefuseDialog: "TravellerSingle/entry_refuse_dialog",
    }),
  },
  methods: {
    async save() {
      if (this.$refs.manualRef.validate()) {
        try {
          this.loading = true;
          const formData = new FormData();
          if (this.entryRefuseData.submission_no && this.entryRefuseData.submission_no !== undefined)
            formData.append("submission_no", this.entryRefuseData.submission_no);
          if (this.entryRefuseData.entry_refuse_date && this.entryRefuseData.entry_refuse_date !== undefined)
            formData.append("entry_refuse_date", this.entryRefuseData.entry_refuse_date);
          formData.append("flight_number", this.entryRefuseData.flight_number);
          formData.append("purpose_of_visit", this.entryRefuseData.purpose_of_visit);
          formData.append("remarks", this.entryRefuseData.remarks);
          formData.append("file", this.entryRefuseData.file)
          formData.append("type", "arrival")
          formData.append("traveller_id", this.travellerId)
          formData.append("country_name", this.countryName)

          await Http.post(`${VERSIONED_API_URL}/traveller/entry/refuse`, formData);
          this.$store.commit("TravellerSingle/setEntryRefuseDialog", false);
          this.$store.commit("Notification/showSuccess", "Traveller Entry Refused Successfully.");
          this.entryRefuseData = {};
          this.loading = false;
          this.$emit('input', false);
          this.$emit('entryRefused');

        } catch
            (e) {
          this.loading = false;
          this.$store.commit('Notification/showError', e.response.data.message);
          this.errors = e.response.data.errors;
        }
      }
    },
    cancel() {
      this.entryRefuseData = {};
      this.$store.commit("TravellerSingle/setEntryRefuseDialog", false);
      this.$emit('input', false)
    }
  }
}
</script>

